import React, { useRef, useState, useEffect } from 'react';
import { Tooltip } from 'antd';
const WidthAwareTooltip = ({children,title,width}) =>{
 
    const textRef = useRef(null);
    const [showTooltip, setShowTooltip] = useState("");

    useEffect(() =>{
        if(textRef.current){
            const element = textRef.current;
            const isOverflowing = element.scrollWidth > element.offsetWidth;
            setShowTooltip(isOverflowing);
        }
    },[children,width]);

    return showTooltip ? (
        <Tooltip title={title}>
            <div ref ={textRef}
               style={{
                width: `${width}px`,
                textOverflow:'ellipsis',
                whiteSpace:'nowrap'
               }}>
                {children}
            </div>
        </Tooltip>) : (
          <div ref ={textRef}
               style={{
                width: `${width}px`,
                overflow: 'hidden',
                textOverflow:'ellipsis',
                whiteSpace:'nowrap'
               }}>
                {children}
            </div>
        )
}

export default WidthAwareTooltip;